import { useSelector } from "react-redux";

const usePermissions = () => {
  const permissions = useSelector((state) => state.session?.permissions || []);

  /**
   * Check if user has a specific permission
   * @param {string} permissionKey - The permission key to check (e.g., "dashboard", "configuration.admin_users")
   * @returns {boolean} - True if user has the permission, false otherwise
   */
  const hasPermission = (permissionKey) => {
    if (!permissionKey) return false;
    return permissions.some((permission) => permission.key === permissionKey);
  };

  /**
   * Check if user has ANY of the specified permissions
   * Useful for parent items that should show if user has any child permission
   * @param {string[]} permissionKeys - Array of permission keys to check
   * @returns {boolean} - True if user has at least one of the permissions, false otherwise
   */
  const hasAnyPermission = (permissionKeys) => {
    if (!Array.isArray(permissionKeys) || permissionKeys.length === 0) return false;
    return permissionKeys.some((key) => hasPermission(key));
  };

  /**
   * Get all user permissions
   * @returns {Array} - Array of permission objects from the user's role
   */
  const getAllPermissions = () => {
    return permissions;
  };

  return {
    hasPermission,
    hasAnyPermission,
    getAllPermissions,
  };
};

export default usePermissions;
